import React from "react";

import { SkeletonBlock } from "../../../Skeletons/primitives";

/**
 * Search results skeleton — replaces hardcoded pixel-width Skeleton.Input elements.
 * Uses flex layout with percentage-based widths for responsiveness.
 */
const SearchSkeleton = () => {
  return (
    <div className="mt-[5px] flex flex-col gap-1">
      {/* Result group 1 */}
      <SkeletonBlock width="90%" height={15} radius="sm" />
      <SkeletonBlock width="50%" height={15} radius="sm" />
      <div className="my-3 h-[1px] w-full bg-grey" />

      {/* Result group 2 */}
      <SkeletonBlock width="70%" height={15} radius="sm" />
      <SkeletonBlock width="35%" height={15} radius="sm" />
      <div className="my-2 h-[1px] w-full bg-grey" />

      {/* Result group 3 */}
      <SkeletonBlock width="50%" height={15} radius="sm" />
      <SkeletonBlock width="25%" height={15} radius="sm" />
    </div>
  );
};

export default SearchSkeleton;
